import { render } from "./ImageComponentViewer.vue?vue&type=template&id=48892f93&scoped=true&ts=true"
import script from "./ImageComponentViewer.vue?vue&type=script&lang=ts"
export * from "./ImageComponentViewer.vue?vue&type=script&lang=ts"

import "./ImageComponentViewer.vue?vue&type=style&index=0&id=48892f93&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48892f93"]])

export default __exports__